<template>
  <div class="aspect-square shrink-0 overflow-hidden rounded-md" style="width: 15%">
    <span
      class="bg-grey-4 inline-flex aspect-square h-full w-full items-center justify-center rounded-md font-semibold"
    >
    </span>
  </div>
  <div
    class="flex flex-shrink flex-col gap-1 text-xs"
    style="color: #48454e"
    :style="{ width: `calc(100%${image ? ' - 13.2%' : ''} - 15.2% - 13.2%)` }"
  >
    <div class="flex w-full flex-shrink flex-grow" style="gap: 2%">
      <span class="flex-shrink truncate font-semibold" style="color: #1c1b1f">{{
        title || "Recurly Engage"
      }}</span
      ><span>•</span><span>5m</span>
    </div>
    <div class="truncate">{{ message || "⠀" }}</div>
  </div>
  <div class="flex-grow" style="min-height: 15%"></div>
  <div v-if="image" class="aspect-square shrink-0 overflow-hidden rounded-md" style="width: 15%">
    <img class="block h-full w-full object-cover" :src="image" />
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: "Title" },
  message: { type: String, default: "Message" },
  image: { type: String, default: "" },
});
</script>
